angular.module('impactx.system').controller('ThirdPartyLicencesCtrl', [
    '$scope',
    'dataGen',
    'ToolbarService',
    ThirdPartyLicencesCtrl]);

function ThirdPartyLicencesCtrl($scope, dataGen, ToolbarService) {
    dataGen.getData($scope, {}, "/systemadministration/thirdpartylicences").then(function() {
        ToolbarService.setButtons([]);
    });
}